import { useGallery } from "../lib/useGallery";
import { Reveal } from "./Reveal";
import { IMG } from "../data/site";

// Brand imagery from the Lux Veritae Vagaro page; owner uploads (inbox → Brand Photos) replace it.
const DEFAULT_MUSE = [
  { id: "glow", url: IMG.museGlow, caption: "" },
  { id: "neck", url: IMG.museNeck, caption: "" },
  { id: "hands", url: IMG.museHands, caption: "" },
];

export const Lookbook = () => {
  const { brand } = useGallery();
  const items = brand.length ? brand : DEFAULT_MUSE;
  return (
    <section className="bg-white pb-24 md:pb-32" data-testid="lookbook-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <Reveal><p className="kicker mb-10 text-center">The Lux Veritae Muse</p></Reveal>
        <div className="no-scrollbar flex snap-x gap-6 overflow-x-auto md:justify-center">
          {items.map((b) => (
            <figure key={b.id} className="w-[72vw] shrink-0 snap-start sm:w-[380px]" data-testid={`lookbook-item-${b.id}`}>
              <div className="aspect-[3/4] overflow-hidden bg-neutral-100"><img src={b.url} alt={b.caption || "Lux Veritae muse"} className="img-zoom h-full w-full object-cover" loading="lazy" /></div>
              {b.caption && <figcaption className="font-display mt-4 text-xl text-neutral-900">{b.caption}</figcaption>}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
